module.exports = __webpack_public_path__ + "img/time.453c4957.png";